module.exports = __webpack_public_path__ + "static/nu_ultravioleta-logo-ee4f5558a138143fc7a4058202ba0423.png";